type ContactPayload = {
  name: string;
  email: string;
  phone?: string;
  message: string;
};

export async function submitContactForm(
  locale: string,
  payload: ContactPayload,
) {
  const res = await fetch('/api/contact', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ locale, ...payload }),
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`API /api/contact failed (${res.status}): ${text}`);
  }

  return res.json();
}
